import styled from 'styled-components';

export const FlexCellContent = styled.div.attrs<{ className?: string }>({ className: 'table-cell-content' })`
  margin: 0;
  display: flex;
  gap: 5px;
`;
